import React, { useState } from "react";

import { Input, Select, Typography } from "clearsense-ui/components";

import { FREQUENCY_OPTIONS, NAMESPACE_OPTIONS } from "./constants";

const Replication = ({ replication, setReplication }) => {
  const [isCustomFormat, setIsCustomFormat] = useState(
    replication?.namespaceDefinition?.value === "customformat"
  );

  const handleChange = selectedFormat => {
    setReplication(prev => ({ ...prev, namespaceDefinition: selectedFormat }));
    setIsCustomFormat(selectedFormat.value === "customformat");
  };

  return (
    <div className="space-y-4">
      <Typography style="h4" className="border-b-2">
        Replication
      </Typography>
      <Select
        label="Replication frequency"
        autoFocus
        required
        className="w-3/4 mt-4"
        value={replication?.frequency}
        helpText="Set how often data should sync to the destination"
        options={FREQUENCY_OPTIONS}
        onChange={option =>
          setReplication({ ...replication, frequency: option })
        }
      />
      <Select
        label="Destination Namespace"
        placeholder="Select a Namespace"
        helpText="Define the location where the data will be stored in the destination"
        options={NAMESPACE_OPTIONS}
        required
        value={replication?.namespaceDefinition}
        onChange={option => handleChange(option)}
      />
      {isCustomFormat && (
        <Input
          label="Namespace custom format"
          value={replication?.namespaceFormat}
          onChange={({ target: { value } }) =>
            setReplication({ ...replication, namespaceFormat: value })
          }
          required
          placeholder="Enter a custom format"
          helpText="A format string to use as namespace in the destination. Special variables: ${SOURCE_NAMESPACE}"
        />
      )}
    </div>
  );
};

export default Replication;
